function unmark(el) {
  Array.from(el.querySelectorAll('._mark_'))
    .forEach((marker) => marker.parentNode.removeChild(marker));
}

function mark(el, binding) {
  const text = el.firstChild;

  if (!text || text.nodeType !== 3 || !text.data) {
    return;
  }

  const wordsAmount = binding.value || 1;
  const words = text.data.split(/\s+/);

  el.setAttribute('data-marked', text.data);

  if (words.length - wordsAmount > 0) {
    text.data = ` ${words.slice(wordsAmount).join(' ')}`;
  } else {
    text.data = '';
  }

  const marker = document.createElement('span');
  marker.classList.add('marker');
  marker.classList.add('_mark_');
  marker.textContent = words.slice(0, wordsAmount).join(' ');
  el.insertBefore(marker, text);
}

export const markWord = {
  name: 'mark-word',
  beforeMount: mark,
  updated(el, binding) {
    const text = el.textContent;

    if (text !== el.getAttribute('data-marked')) {
      unmark(el);
      mark(el, binding);
    }
  },
};
